

<body class="mat-app-backgorund">
    <div class="mat-elevation-z8 ccorbit-mat-table listas col-panel-wrapper" [cdkContextMenuTriggerFor]="context_menu" *ngIf="!isBroker">
        <div class="floating-col-panel" (mouseleave)="contraerColPanel()"
             [ngClass]="{'expanded': colPanelOpen}">
          <div class="col-panel-toggle" (mouseenter)="expandirColPanel()">
            <mat-icon>{{colPanelOpen ? 'chevron_left' : 'view_column'}}</mat-icon>
          </div>
          <div class="col-panel-content">
            <h6 class="col-panel-title mb-2">Columnas</h6>
            <div class="col-panel-option" *ngFor="let column of tableColumns">
              <mat-checkbox [checked]="column.isShow" (change)="toggleColumnVisibility(column.id)" [color]="'primary'">
                {{column.name}}
              </mat-checkbox>
            </div>
          </div>
        </div>
        <app-mercado-select class="select listas"
            [mercados]="mercados"
            [countdownFn]="countdownLabelFn"
            [(ngModel)]="idMercado"
            (ngModelChange)="buscarCompania()">
        </app-mercado-select>

        <cdk-virtual-scroll-viewport #viewportGestor id="viewportGestor" item [appendOnly]="false" [tvsItemSize]="24"
        [headerHeight]="34" class="wrapper mat-elevation-z2 tableStyle" *ngIf="isGestor" >
            <table cdk-table [dataSource]="companiaMercado" class="table-striped tableStyle">

                <tr cdk-header-row *cdkHeaderRowDef="displayedColumns; sticky: true" class="sticky-header"></tr>
                <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;" (click)="selectRow(row)"
                    [ngClass]="{'selected': row === filaSeleccionada}" (contextmenu)="mostrarMenu($event, row)"></tr>
                <ng-container *ngFor="let tablecol of tableColumns">

                    <ng-container [cdkColumnDef]="tablecol.id">
                        <th cdk-header-cell *cdkHeaderCellDef="" class="sticky-header"
                            (click)="orderByGestor(tablecol.id)"
                            [class.sorted]="sortStateGestor.active === tablecol.id">
                          {{tablecol.name}}
                          <mat-icon class="sort-icon" *ngIf="sortStateGestor.active === tablecol.id">
                            {{ sortStateGestor.direction === 'asc' ? 'arrow_upward' :
                               (sortStateGestor.direction === 'desc' ? 'arrow_downward' : '') }}
                          </mat-icon>
                        </th>
                        <td cdk-cell *cdkCellDef="let item" [ngClass]="{'salida': item[tablecol.id] === 'SALIDA',
                                                                'entrada': item[tablecol.id] === 'ENTRADA',
                                                                'numero-positivo': item[tablecol.id] > 0,
                                                                'numero-negativo': item[tablecol.id] < 0
                                                                }">
                            <ng-container *ngIf="tablecol.isString && tablecol.id !== 'iso'">
                                {{item[tablecol.id]}}
                            </ng-container>
                            <a *ngIf="tablecol.id === 'iso'" class="activo-link" [href]="urlMercadoActivo(idMercado, item)" target="_blank" (click)="$event.stopPropagation()">{{item.iso}} <mat-icon>open_in_new</mat-icon></a>
                            <ng-container *ngIf="tablecol.isDate">
                                {{item[tablecol.id] | smartDate }}
                            </ng-container>
                            <ng-container *ngIf="tablecol.isNumber">
                                {{item[tablecol.id] |number:'1.2-2'}}
                            </ng-container>
                            <ng-container *ngIf="tablecol.id === 'hora'">
                                {{item['fecha'] | date: 'HH:mm:ss'}}
                            </ng-container>
                          
                        </td>
                    </ng-container>
                </ng-container>
            </table>
        </cdk-virtual-scroll-viewport>
    </div>
    <div class="mat-elevation-z8 ccorbit-mat-table listas col-panel-wrapper" [cdkContextMenuTriggerFor]="context_menu" *ngIf="isBroker">
        <div class="floating-col-panel" (mouseleave)="contraerColPanel()"
             [ngClass]="{'expanded': colPanelOpen}">
          <div class="col-panel-toggle" (mouseenter)="expandirColPanel()">
            <mat-icon>{{colPanelOpen ? 'chevron_left' : 'view_column'}}</mat-icon>
          </div>
          <div class="col-panel-content">
            <h6 class="col-panel-title mb-2">Columnas</h6>
            <div class="col-panel-option" *ngFor="let column of tableColumns">
              <mat-checkbox [checked]="column.isShow" (change)="toggleColumnVisibility(column.id)" [color]="'primary'">
                {{column.name}}
              </mat-checkbox>
            </div>
          </div>
        </div>
        <app-mercado-select class="select listas"
            [mercados]="mercadosFiltrados"
            [countdownFn]="countdownLabelFn"
            [(ngModel)]="idMercadoBroker"
            (ngModelChange)="buscarCompania()">
        </app-mercado-select>

        <cdk-virtual-scroll-viewport #viewportBroker id="viewportBroker" item [appendOnly]="false" [tvsItemSize]="24"
        [headerHeight]="34" class="wrapper mat-elevation-z2 tableStyle" *ngIf="isGestor" >
            <table cdk-table [dataSource]="BrokerCompMercado" class="table-striped tableStyle">

                <tr cdk-header-row *cdkHeaderRowDef="displayedColumns; sticky: true" class="sticky-header"></tr>
                <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;" (click)="selectRow(row)"
                    [ngClass]="{'selected': row === filaSeleccionada}" (contextmenu)="mostrarMenu($event, row)"></tr>
                <ng-container *ngFor="let tablecol of tableColumns">

                    <ng-container [cdkColumnDef]="tablecol.id" >
                        <th cdk-header-cell *cdkHeaderCellDef="" class="sticky-header"
                            (click)="orderByBroker(tablecol.id)"
                            [class.sorted]="sortStateBroker.active === tablecol.id">
                          {{tablecol.name}}
                          <mat-icon class="sort-icon" *ngIf="sortStateBroker.active === tablecol.id">
                            {{ sortStateBroker.direction === 'asc' ? 'arrow_upward' :
                               (sortStateBroker.direction === 'desc' ? 'arrow_downward' : '') }}
                          </mat-icon>
                        </th>
                        <td cdk-cell *cdkCellDef="let item" [ngClass]="{'salida': item[tablecol.id] === 'SALIDA',
                                                                'entrada': item[tablecol.id] === 'ENTRADA',
                                                                'numero-positivo': item[tablecol.id] > 0,
                                                                'numero-negativo': item[tablecol.id] < 0
                                                                }">
                            <ng-container *ngIf="tablecol.isString && tablecol.id !== 'iso'">
                                {{item[tablecol.id]}}
                            </ng-container>
                            <a *ngIf="tablecol.id === 'iso'" class="activo-link" [href]="urlMercadoActivo(idMercadoBroker, item)" target="_blank" (click)="$event.stopPropagation()">{{item.iso}} <mat-icon>open_in_new</mat-icon></a>
                            <ng-container *ngIf="tablecol.isDate">
                                {{item[tablecol.id] | smartDate }}
                            </ng-container>
                            <ng-container *ngIf="tablecol.isNumber">
                                {{item[tablecol.id] |number:'1.2-2'}}
                            </ng-container>
                        </td>
                    </ng-container>
                </ng-container>
            </table>
        </cdk-virtual-scroll-viewport>
    </div>
    <ng-template #context_menu let-data="data">
        <div class="example-menu" cdkMenu [ngClass]="{'dark-theme': isDark, 'light-theme': !isDark}">
          <button class="example-menu-item" (click)="verGrafica()" cdkMenuItem>
            <mat-icon class="menu-icon">insert_chart</mat-icon>
            <span>Ver Gráfica</span>
          </button>
          <button class="example-menu-item" (click)="openDialog()" cdkMenuItem>
            <mat-icon class="menu-icon">send</mat-icon>
            <span>Operaciones de Entrada</span>
          </button>
        </div>
      </ng-template>

</body>